<script setup>
import { DropdownMenuContent, DropdownMenuPortal } from 'radix-vue'
import { cn } from '@/lib/utils'

/**
 * `collisionPadding` is the fix for a layout that jumped on open.
 *
 * The panel is positioned against the trigger, and the trigger sits at the right
 * edge of a full-width header. Without a collision boundary the panel was placed
 * partly past the viewport, the document gained a horizontal scrollbar, and
 * every centred container shifted left the moment the menu opened — which reads
 * as the header breaking rather than as a scrollbar appearing.
 */
const props = defineProps({
  class: { type: String, default: '' },
  sideOffset: { type: Number, default: 4 },
  align: { type: String, default: 'end' },
  collisionPadding: { type: [Number, Object], default: 12 },
  avoidCollisions: { type: Boolean, default: true },
})
</script>

<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      :side-offset="props.sideOffset"
      :align="props.align"
      :collision-padding="props.collisionPadding"
      :avoid-collisions="props.avoidCollisions"
      :class="cn(
        'z-50 min-w-[8rem] overflow-hidden rounded-md border border-gray-200 bg-white p-1 text-gray-900 shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        props.class
      )"
    >
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>
